import AppModal from '../../../sharedcomponents/5templates/modal/appModal/AppModal'

const getActionButtonText = (type) =>
  (type === 'save' && 'Save') ||
  (type === 'deletion' && 'Delete') ||
  (type === 'cancellation' && 'Accept')

const getHeaderText = (type) =>
  (type === 'save' && 'Save Changes') ||
  (type === 'deletion' && 'Delete Heatmap') ||
  (type === 'cancellation' && 'Cancel Changes')

const getConfig = (type, open, handleClose, confirmFunction) => ({
  type,
  open,
  handleClose,
  headerText: getHeaderText(type),
  buttons: {
    ...(type === 'error' && {
      actionButton: {
        text: 'Close',
        actionFunction: handleClose,
        secondaryButton: true
      }
    }),
    ...(type !== 'error' && {
      actionButton: {
        text: getActionButtonText(type),
        actionFunction: confirmFunction || handleClose,
        secondaryButton: false
      },
      cancel: {
        text: 'Cancel',
        actionFunction: handleClose,
        secondaryButton: true
      }
    })
  }
})

const HMapModal = ({ type, open, setOpen, confirmFunction, messageText }) => {
  const handleClose = () => setOpen(false)

  return (
    <AppModal config={getConfig(type, open, handleClose, confirmFunction)}>
      {messageText}
    </AppModal>
  )
}

export default HMapModal
